import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import {MyMess} from '../../App';
import QRCode from "react-qr-code";
import { makeStyles, TextField, Typography } from '@material-ui/core';
import Box from "@material-ui/core/Box";

var paymAlipayHK = require("../../images/payments/paymAlipayHK.png");
var paymWechatPay = require("../../images/payments/paymWechatPay.png");

const useStyles = makeStyles((theme) => ({ 
    box: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    wechat: {
        padding: 30,
        width: "auto",
        backgroundColor: "#1AAD19",
     },
    wechatLogo: {
        marginTop: 10,
        width: 200,
        height: 61,
        margin: "auto"
     },
     alipay: {
        padding: 30,
        width: "auto",
        backgroundColor: "#00aeef"
     },
     alipayLogo: {
        marginTop: 10,
        width: 140,
        height: 32,
        margin: "auto"
     },
  }));
  

 export default function QrCode(props) {
    const classes = useStyles();
    const { qrCode } = props;
    let qrCodeType = props.qrCodeType || 'alipay';
    let imageSrc;
    if (qrCodeType == 'alipay') {
        imageSrc = paymAlipayHK;
    } else if (qrCodeType == 'wechat') {
        imageSrc = paymWechatPay;
    }
  
    const [isProcessing, setProcessing] = React.useState(false);

    return (
        <Box className={classes.box} width={300} >
            <div className={classes[qrCodeType]} >
                <QRCode
                        value={qrCode}
                        level="M"
                        size={240}
                    />
            </div>
            <img className={classes[`${qrCodeType}Logo`]} src={imageSrc} />
        </Box>
        
        
    );
}

QrCode.propTypes = {
    qrCode: PropTypes.string.isRequired,
    qrCodeType: PropTypes.string,
     
};
